import { Badge } from "@jhool-io/fe-components";
import { removeEnumUnderscore, truncateString } from "../../../utils/helpers";
import {
    PrescriptionEventStatues,
    PrescriptionStatus,
} from "../types/e-prescribe.types";

export const getStatusForDisplay = (status: string | null) => {
    if (!status) return "--";
    if (status === "active") {
        return <Badge content={status} type="success" />;
    }
    if (status === "inactive") {
        return <Badge content={status} type="danger" />;
    }
    if (status === "discontinued") {
        return <Badge content={status} type="danger" />;
    }
    if (status === "pending") {
        return <Badge content={status} type="warning" />;
    }

    return <Badge content={status} type="neutral" />;
};

export const getPrecriptionStatusForDisplay = (status: PrescriptionStatus) => {
    switch (status) {
        case PrescriptionEventStatues.SENT:
        case PrescriptionEventStatues.SENT_NEEDS_SIGNATURE:
        case PrescriptionEventStatues.SENT_SIGNED:
        case PrescriptionEventStatues.COMPLETED_NEEDS_SIGNATURE:
            return <Badge content={removeEnumUnderscore(status)} type="info" />;

        case PrescriptionEventStatues.PENDING:
        case PrescriptionEventStatues.NEEDS_REVIEW:
            return (
                <Badge content={removeEnumUnderscore(status)} type="warning" />
            );

        case PrescriptionEventStatues.VOIDED:
            return (
                <Badge content={removeEnumUnderscore(status)} type="danger" />
            );

        case PrescriptionEventStatues.COMPLETED_SIGNED:
            return (
                <Badge content={removeEnumUnderscore(status)} type="danger" />
            );

        default:
            return <Badge content={status} type="neutral" />;
    }
};

export const getFilterButtonText = (
    defaultValue: string,
    filterValue?: string | null,
    length?: number
) => {
    if (!filterValue) return defaultValue;
    return filterValue.length > (length ?? 15)
        ? truncateString(removeEnumUnderscore(filterValue), length ?? 15)
        : removeEnumUnderscore(filterValue);
};
